import React from "react";

interface StopPopupBodyMotionProps {

    /** Optional body background from stop popup theme. */
    "backgroundColor"?: string;

    /** Body content. */
    "children": React.ReactNode;
}

/**
 * Static padded wrapper for the stop popup body.
 * Arrivals loading uses in-place row swap inside a fixed-height list — no phase crossfade.
 *
 * @param props Body wrapper props.
 * @returns Popup body shell.
 */
const StopPopupBodyMotion: React.FC<StopPopupBodyMotionProps> = ( {
    backgroundColor,
    children,
} ) => (
    <div
        className="px-1.5 overflow-hidden"
        style={{ "backgroundColor": backgroundColor }}
    >
        {children}
    </div>
);

export default StopPopupBodyMotion;
